// 签到成功弹出
<template>
  <div class="sigInSuccess">
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      width="488px"
      :lock-scroll="false"
      :modal-append-to-body="false"
    >
      <div class="box">
        <div class="sigInSuccess_diaog">
          <div class="btn" @click="onclose"></div>
          <div class="time">有效期至：{{ time }}</div>
        </div>
        <img src="@/assets/image/signinSuccessbg.webp" class="bg" alt="" srcset="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
    };
  },
  created() {},
  computed: {
    time() {
      return dayjs().add(3, "day").format("YYYY-MM-DD HH:mm");
    },
  },
  methods: {
    onshow() {
      this.dialogVisible = true;
    },
    onclose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.sigInSuccess {
  ::v-deep .el-dialog {
    background-color: rgba($color: #000000, $alpha: 0);
    box-shadow: none;
    margin-top: 0px !important;

    &__header {
      padding: 0;
    }

    &__body {
      padding: 0;
      background-color: rgba($color: #000000, $alpha: 0);
    }
  }

  &_diaog {
    // margin-top: calc((100vh - 565px) / 3);
    margin-top: 50px;
    background-image: url(~@/assets/image/signinSuccess.webp);
    width: 448px;
    height: 251px;
    background-size: 448px 251px;
    background-repeat: no-repeat;
    position: relative;
    z-index: 2;
    .btn {
      width: 50px;
      height: 30px;
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
      z-index: 3;
    }
    .time {
      font-size: 12px;
      font-weight: 350;
      line-height: normal;
      color: #666666;
      position: absolute;
      z-index: 3;
      bottom: 70px;
      left: 175px;
    }
  }
  .box {
    overflow: hidden;
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .bg {
      height: 323px;
      position: absolute;
      z-index: 1;
      left: 0;
      top: 20px;
      animation: spin 10s linear infinite;
    }
  }
}
</style>
